import { Component, OnInit, Input } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import {LegendItemComponent} from './legend-item/legend-item.component'


export interface ILegendItem {
  title: string;
  color: string;
}
@Component({
    selector: 'app-legend',
    imports: [FlexLayoutModule, LegendItemComponent],
    templateUrl: './legend.component.html',
    styleUrl: './legend.component.scss'
})
export class LegendComponent implements OnInit{
@Input() data: ILegendItem[];

  ngOnInit(): void {    
  }
}
